import React, { useEffect, useRef } from "react";
import jexcel from "jspreadsheet-ce";
import '../../assets/css/spreadsheet.css';
import { Stack, StackProps } from "@chakra-ui/react";

interface SpreadsheetTableProps extends StackProps {
    data: any[][],
    columns: any[],
    tableHeight?: string;
}

export default function SpreadsheetTable(props: SpreadsheetTableProps) {
    const jexcelContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {

        if (jexcelContainerRef.current) {
            const ji = jexcel(jexcelContainerRef.current, {
                minDimensions: [1, 1],
                tableOverflow: true,
                allowInsertColumn: false,
                tableHeight: props.tableHeight ?? '300px',
                tableWidth: "100%",
                allowManualInsertColumn: false,
                allowDeleteRow: true,
                allowDeleteColumn: false,
                columns: props.columns
            });
            props.data.map(row => ji.insertRow(row));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [jexcelContainerRef])

    return (
        <Stack
            ref={jexcelContainerRef}
            {...props}
        >
        </Stack>
    );
}